import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faWhatsapp,
  faWhatsappSquare,
} from '@fortawesome/free-brands-svg-icons';
import { Button, Input } from '@quero-delivery/quero-components-web';
import type { SubmitHandler } from 'react-hook-form';
import { useForm, Controller } from 'react-hook-form';

import Tooltip from 'rc-tooltip';
import { faPhoneSquareAlt } from '@fortawesome/pro-solid-svg-icons';
import { image } from '@/Themes/Images';
import { colors } from '@/Themes/Colors';
import styles from './Login.module.scss';
import { requiredErrorMessage } from '@/infra/YupDecorator';
import { Targe } from '@/_components/targe';
import { useAppDispatch, useAppSelector } from '@/_store/hooks';
import { authRequest } from '@/_store/modules/auth';

const NumberAjuda = '(79) 999839-1112';

interface ILogin {
  login: string;
  password: string;
}

const Login = () => {
  const dispatch = useAppDispatch();

  const [modalTelefone, setModalTelefone] = useState(false);

  const loading = useAppSelector(state => state.auth.fetching);

  const {
    handleSubmit,
    control,
    formState: { errors },
  } = useForm<ILogin>();

  const handleSubmitForm: SubmitHandler<ILogin> = async data => {
    dispatch(authRequest(data));
  };

  return (
    <div className={styles.containerLogin}>
      <Targe />
      <div className={styles.containerImg}>
        <img src={image.logo} alt="logo-querolog" />

        <div className={styles.containerImgName}>
          <span>Bem-vindo ao</span>
          <strong>Querolog</strong>
        </div>
      </div>
      <div className={styles.containerContent}>
        <div className={styles.containerCardButton}>
          <div className={styles.cardLogin}>
            <form onSubmit={handleSubmit(handleSubmitForm)} id="form-login">
              <Controller
                name="login"
                control={control}
                rules={{
                  required: requiredErrorMessage,
                }}
                render={({ field }) => (
                  <Input
                    {...field}
                    label="Login"
                    errorMessage={errors.login?.message}
                  />
                )}
              />

              <Controller
                name="password"
                control={control}
                rules={{
                  required: requiredErrorMessage,
                }}
                render={({ field }) => (
                  <Input
                    {...field}
                    label="Senha"
                    errorMessage={errors.password?.message}
                    type="password"
                  />
                )}
              />
            </form>
          </div>

          <div
            id="recatpcha-v2"
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginBottom: 20,
            }}
          />

          <Button
            textFirst="entrar"
            strong
            backPurple
            loading={loading}
            disabled={loading}
            type="submit"
            form="form-login"
            width="100%"
          />
        </div>

        <Tooltip
          visible={modalTelefone}
          animation="zoom"
          onVisibleChange={() => setModalTelefone(!modalTelefone)}
          trigger="click"
          placement="top"
          overlay={
            <div className={styles.buttonsShare}>
              <div
                className={styles.buttonShare}
                onClick={() =>
                  window.open(
                    `https://wa.me/5579998391112?text=${encodeURI(
                      `Olá, poderia me ajudar?`,
                    )}`,
                  )
                }
              >
                <FontAwesomeIcon
                  icon={faWhatsappSquare}
                  color={colors.brandGreen}
                  size="4x"
                />
              </div>
              <div
                className={styles.buttonShare}
                onClick={() => {
                  window.open(`tel:+${5579998391112}`, '_top');
                }}
              >
                <FontAwesomeIcon
                  icon={faPhoneSquareAlt}
                  color={colors.info20}
                  size="4x"
                />
              </div>
            </div>
          }
        >
          <div
            className={styles.footerLogin}
            onClick={() => setModalTelefone(!modalTelefone)}
          >
            <span className={styles.label}>Precisando de ajuda?</span>
            <div
              style={{
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <FontAwesomeIcon
                icon={faWhatsapp}
                color="#f7ea48"
                style={{
                  marginRight: 5,
                  fontWeight: 'bold',
                }}
                size="lg"
              />
              <span className={styles.number}>{NumberAjuda}</span>
            </div>
          </div>
        </Tooltip>
      </div>
    </div>
  );
};

export default Login;
